module.exports = __webpack_public_path__ + "static/media/7.question_loop.62e90f84.mp4";